var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 323",
    width: 400,
    height: 323,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LTI logo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #2f3187 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M46.56 13.46L46.56 148.59L87.48 127.84L87.48 13.46L46.56 13.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M46.56 149.6L153.8 149.6L153.8 190.52L46.56 190.52L46.56 149.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M144.22 13.46L275.59 13.46L275.59 54.38L144.22 54.38L144.22 13.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M230.37 190.52L189.44 190.52L189.44 76.15L230.37 55.39L230.37 190.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M308.98 34.23L308.98 190.52L349.9 190.52L349.9 13.5L308.98 34.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M391.92 295.5L358.63 295.5C359.26 304.56 364.24 310.46 372.52 310.46C378.11 310.46 382.77 307.7 386 303.37L390.35 305.81C386.32 311.81 379.93 315.03 372.52 315.03C360.6 315.03 352.55 306.36 352.55 293.38C352.55 280.47 360.43 271.8 372.34 271.8C384.11 271.8 391.99 280.22 391.99 292.9C391.99 293.61 391.99 294.56 391.92 295.5ZM358.54 291.49L386.08 291.49C385.51 282.18 380.39 276.36 372.34 276.36C364.22 276.36 359.17 282.27 358.54 291.49ZM330.38 314.24L324.61 314.24L305.99 272.58L312.24 272.58L327.46 307.7L342.67 272.58L348.92 272.58L330.38 314.24ZM291.32 253.32L297.01 253.32L297.01 309.52L305.83 309.52L305.83 314.24L291.32 314.24L291.32 253.32ZM238.39 293.45C238.39 280.45 246.98 271.78 259.76 271.78C272.47 271.78 280.99 280.45 280.99 293.45C280.99 306.36 272.47 315.03 259.76 315.03C246.98 315.03 238.39 306.36 238.39 293.45ZM274.99 293.45C274.99 283.35 268.91 276.75 259.76 276.75C250.54 276.75 244.39 283.37 244.39 293.45C244.39 303.45 250.53 310.14 259.76 310.14C268.91 310.14 274.99 303.46 274.99 293.45ZM211.04 287.55L207.49 286.37C199.9 283.93 193.53 280.4 193.53 271.18C193.53 261.57 200.87 255.18 211.83 255.18C219.01 255.18 224.31 257.62 228.48 261.88L225.71 266.04C221.91 262.19 217.43 260.14 211.82 260.14C204.55 260.14 199.74 264.24 199.74 270.3C199.74 276.76 204.72 278.97 210.47 280.93L214.01 282.11C221.65 284.72 230.65 288.73 230.65 299.05C230.65 308.65 222.92 315.03 211.33 315.03C204.46 315.03 197.98 312.89 193.89 308.25L196.25 303.99C200.43 308.34 205.5 310.07 210.94 310.07C219.22 310.07 224.42 305.96 224.42 299.67C224.42 293.06 218.83 290.15 211.04 287.55ZM150.74 295.97L146.72 294.65C140.8 292.69 136.54 290.23 136.54 283.94C136.54 276.62 141.97 271.81 150.09 271.81C155.32 271.81 159.48 273 163.19 275.59L160.75 279.44C157.59 277.24 154.12 276.37 150.48 276.37C145.68 276.37 142.36 278.97 142.36 283.06C142.36 286.92 145.35 288.57 149.3 289.9L153.32 291.24C159.08 293.13 164.29 296.13 164.29 302.98C164.29 310.23 158.69 315.03 149.86 315.03C144.43 315.03 139.61 313.53 136.61 310.61L138.97 307.08C142.12 309.61 146 310.47 149.86 310.47C155 310.47 158.46 307.72 158.46 303.46C158.46 299.59 155.14 297.39 150.74 295.97ZM128.1 273.14L123.05 273.14L128.34 255.69L134.34 255.69L128.1 273.14ZM107.04 277.31L107.04 314.24L101.35 314.24L101.35 277.31L90.94 277.31L90.94 272.58L101.35 272.58L101.35 260.39L107.04 260.39L107.04 272.58L117.44 272.58L117.44 277.31L107.04 277.31ZM87.22 295.5L53.94 295.5C54.56 304.56 59.54 310.46 67.82 310.46C73.41 310.46 78.07 307.7 81.3 303.37L85.65 305.81C81.62 311.81 75.23 315.03 67.82 315.03C55.9 315.03 47.85 306.36 47.85 293.38C47.85 280.47 55.74 271.8 67.64 271.8C79.41 271.8 87.29 280.22 87.29 292.9C87.29 293.61 87.29 294.56 87.22 295.5ZM53.84 291.49L81.38 291.49C80.83 282.18 75.71 276.36 67.64 276.36C59.52 276.36 54.47 282.27 53.84 291.49ZM44.62 314.24L11 314.24L11 253.32L17 253.32L17 309.27L44.62 309.27L44.62 314.24Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLti);
export default __webpack_public_path__ + "static/media/lti.dea3daae9cbccc38364554d2f44d186e.svg";
export { ForwardRef as ReactComponent };